import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import TagBeltInfoMobile from '../../../pages/Mobile/Belts/TagBeltInfoMobile';
import TagBeltInfoDesktop from '../../../pages/TagBeltInfoDesktop';

const TagBeltResponsive = () => {
    const { isMobile } = useResponsiveRedux();

    return isMobile ? <TagBeltInfoMobile /> : <TagBeltInfoDesktop />;
};

export default TagBeltResponsive;